export function extraerPrimerElementoDeArrayDeClaves(arrayDeClaves) {
  if (arrayDeClaves !== undefined) {
    const elementoKey = Object.keys(arrayDeClaves)[0];
    return arrayDeClaves[elementoKey];
  }
  return null;
}
export function sortByKeys(sortBy, values) {
  const sortByKeys = Object.keys(sortBy);
  return [...values].sort((a, b) => {
    let out = 0;
    sortByKeys.forEach((key, index) => {
      if (values.length > 0) {
        if (out === 0 && (a[key] !== b[key] || index === sortByKeys.length - 1)) {
          if (typeof a[key] === 'string') {
            // eslint-disable-next-line no-nested-ternary
            out = sortBy[key] === 'DESC' ? (a[key] > b[key] ? 1 : -1) : (a[key] < b[key] ? 1 : -1);
          } else if (typeof a[key] === 'number') {
            out = sortBy[key] === 'DESC' ? b[key] - a[key] : a[key] - b[key];
          } else if (b[key] === undefined && a[key] !== undefined) {
            out = sortBy[key] === 'DESC' ? -1 : 1;
          } else if (a[key] === undefined && b[key] !== undefined) {
            out = sortBy[key] === 'DESC' ? 1 : -1;
          }
        }
      }
    });
    return out;
  });
}
